import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './dashboard.routes';
import dashboardSummary from './dashboardSummary';

export default angular.module('app.components.dashboard', [
  ngRoute,
  dashboardSummary,
])
  .config(routes)
  .name;

console.log('app.components.dashboard created');
